import React, { useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const Navigation = (props) => {
    const navigate = useNavigate();

    useEffect(() => {
        function loadScript(src) {
            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
            });
        }

        loadScript('./assets/js/masonary.js');
    }, []);

    const handleContactClick = (e) => {
        e.preventDefault();
        navigate('/contactus');
    };

    return (
        <>
            <div className={props.bgcolor ? `header-nav navbar-collapse collapse ${props.bgcolor}` : 'header-nav navbar-collapse collapse'}>
                <ul className="nav navbar-nav">
                    <li>
                        <NavLink to={"/"} end className={({ isActive }) => isActive ? "active" : ""}>Home</NavLink>
                    </li>
                    <li>
                        <NavLink to={"/about"} className={({ isActive }) => isActive ? "active" : ""}>Who We Are</NavLink>
                    </li>
                    <li>
                        <NavLink to={"/services"} className={({ isActive }) => isActive ? "active" : ""}>Services</NavLink>
                    </li>
                    <li>
                        <NavLink to={"/blog-masonary"} className={({ isActive }) => isActive ? "active" : ""}>News & Insights</NavLink>
                    </li>
                    <li>
                        <NavLink to={"/project-classic2"} className={({ isActive }) => isActive ? "active" : ""}>Projects</NavLink>
                    </li>
                    <li className="submenu-direction">
                        {/* Contact Us button */}
                        <NavLink to={"/contactus"} className={({ isActive }) => isActive ? "active" : ""} style={{
                            textDecoration: 'none',
                            color: '222222',
                            cursor: 'pointer',
                            background: 'none',
                            border: 'none',
                            font: 'sans-serif'
                        }}>
                            Contact Us
                        </NavLink>
                    </li>
                </ul>
            </div>
        </>
    );
};

export default Navigation;